import { render } from "./ProductCardV2.vue?vue&type=template&id=007b6a77&scoped=true"
import script from "./ProductCardV2.vue?vue&type=script&lang=js"
export * from "./ProductCardV2.vue?vue&type=script&lang=js"

import "./ProductCardV2.vue?vue&type=style&index=0&id=007b6a77&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-007b6a77"]])

export default __exports__